/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HistoricoRequisicaoConsultaAliases {
  AUTOCOMPLETE_DOMAIN = 'autocomplete-domain',
  AVATAR_MOB_SEGURADO = 'avatar-mob-segurado',
  AVATAR_SEGURADO = 'avatar-segurado',
  CONTEXTUAL_BAR_HISTORICO_REQUISICAO_CONSULTA = 'contextual-bar-historico-requisicao-consulta',
  DATE_FIELD_FILTER_0 = 'date-field-filter-0',
  DATE_FIELD_FILTER_1 = 'date-field-filter-1',
  DECK_DESK = 'deck-desk',
  FETCH_BENEFICIARIO = 'fetch-beneficiario',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_DOMAIN = 'fetch-domain',
  FIELD_DOMAIN = 'field-domain',
  FIELD_DS_TIPO_GUIA = 'field-dsTipoGuia',
  FIELD_DT_AUTORIZACAO = 'field-dtAutorizacao',
  FIELD_DT_SOLICITACAO = 'field-dtSolicitacao',
  FIELD_FILTER_DT_FIM = 'field-filter-dtFim',
  FIELD_FILTER_DT_INICIO = 'field-filter-dtInicio',
  FIELD_FILTER_LOCATOR = 'field-filter-locator',
  FIELD_FILTER_NR_SEQ_REQUISICAO = 'field-filter-nrSeqRequisicao',
  FIELD_MOB_DS_TIPO_GUIA = 'field-mob-dsTipoGuia',
  FIELD_MOB_DT_SOLICITACAO = 'field-mob-dtSolicitacao',
  FIELD_MOB_NR_SEQ_REQUISICAO = 'field-mob-nrSeqRequisicao',
  FIELD_MOB_SEGURADO = 'field-mob-segurado',
  FIELD_NM_PRESTADOR = 'field-nmPrestador',
  FIELD_NR_SEQ_GUIA = 'field-nrSeqGuia',
  FIELD_NR_SEQ_REQUISICAO = 'field-nrSeqRequisicao',
  FIELD_SEGURADO = 'field-segurado',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_HISTORICO_REQUISICAO_CONSULTA = 'filtered-list-historico-requisicao-consulta',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPSE = 'hpms-custom-card-content-collapse',
  HPMS_CUSTOM_CARD_DESK = 'hpms-custom-card-desk',
  HPMS_DYNAMIC_CONTENT_COLLAPSE = 'hpms-dynamic-content-collapse',
  HPMS_DYNAMIC_CONTENT_FIELD_ACTION = 'hpms-dynamic-content-field-action',
  HPMS_DYNAMIC_CONTENT_FIELD_ACTION_COLLAPSE = 'hpms-dynamic-content-field-action-collapse',
  HPMS_DYNAMIC_CONTENT_FIELD_MOB = 'hpms-dynamic-content-field-mob',
  HPMS_DYNAMIC_CONTENT_FIELD_STAMP = 'hpms-dynamic-content-field-stamp',
  HPMS_DYNAMIC_CONTENT_FIELD_STAMP_MOB = 'hpms-dynamic-content-field-stamp-mob',
  INPUT_CARTEIRA = 'input-carteira',
  INPUT_NR_SEQ_REQUISICAO = 'input-nrSeqRequisicao',
  LOCATOR_BENEFICIARIO = 'locator-beneficiario',
  LOCATOR_FIELD_0 = 'locator-field-0',
  MAPPER_DOMAIN = 'mapper-domain',
  MAPPER_MOB_SEGURADO = 'mapper-mob-segurado',
  MAPPER_SEGURADO = 'mapper-segurado',
  PANEL_0 = 'panel-0',
  PANEL_HISTORICO_REQUISICAO_CONSULTA = 'panel-historico-requisicao-consulta',
  TEXT_DOMAIN = 'text-domain',
  TEXT_DS_TIPO_GUIA = 'text-dsTipoGuia',
  TEXT_DT_AUTORIZACAO = 'text-dtAutorizacao',
  TEXT_DT_SOLICITACAO = 'text-dtSolicitacao',
  TEXT_MOB_DS_TIPO_GUIA = 'text-mob-dsTipoGuia',
  TEXT_MOB_DT_SOLICITACAO = 'text-mob-dtSolicitacao',
  TEXT_MOB_NR_SEQ_REQUISICAO = 'text-mob-nrSeqRequisicao',
  TEXT_NM_PRESTADOR = 'text-nmPrestador',
  TEXT_NR_SEQ_GUIA = 'text-nrSeqGuia',
  TEXT_NR_SEQ_REQUISICAO = 'text-nrSeqRequisicao',
}
export { HistoricoRequisicaoConsultaAliases };
